import React from "react";

export default function Finance() {
  return (
    <div className="container-fluid py-5">
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">Finance</h1>
          <p className="text-muted">Track your finances and expenses</p>
        </div>
      </div>
    </div>
  );
}
